// extracted by mini-css-extract-plugin
module.exports = {"horizontalBannerScroller":"HorizontalBannerScroller_horizontalBannerScroller__123Jt"};